import { Loader2 } from 'lucide-react';

function StatusBadge({ status }) {
  const isBypassed = String(status || '').toLowerCase().includes('bypass');
  return (
    <span
      className={`inline-flex rounded-full px-1.5 py-0.5 text-[10px] font-medium ${
        isBypassed ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'
      }`}
    >
      {status || '—'}
    </span>
  );
}

/**
 * Time & Labor (and optional absence) rows from existing-approvals SQL — click opens task detail.
 */
export default function BpmConfiguredApprovalsList({
  loading,
  timeLabor = [],
  absences = [],
  selectedTaskName,
  onSelectRow,
  showAbsences = false,
}) {
  const rows = showAbsences ? [...timeLabor, ...absences] : timeLabor;

  if (loading) {
    return (
      <p className="flex items-center gap-2 p-3 text-xs text-slate-500">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Loading configured approvals…
      </p>
    );
  }

  if (!rows.length) {
    return (
      <p className="p-3 text-xs text-slate-500">No configured approval rows from tenant SQL.</p>
    );
  }

  return (
    <ul className="divide-y divide-slate-100">
      {rows.map((row) => {
        const selected =
          selectedTaskName &&
          String(selectedTaskName).toLowerCase() === String(row.name).toLowerCase();
        return (
          <li key={`${row.taskDefinitionName}-${row.name}`}>
            <button
              type="button"
              onClick={() =>
                onSelectRow({
                  name: row.name,
                  code: row.code || null,
                  category: row.category === 'Absences' ? 'absence' : 'time',
                  confirmedOnTenant: true,
                  source: 'sql-existing-approvals',
                })
              }
              className={`flex w-full flex-col gap-0.5 px-2.5 py-2 text-left text-xs ${
                selected
                  ? 'bg-cyan-100 font-medium text-cyan-950 ring-1 ring-inset ring-cyan-200'
                  : 'hover:bg-cyan-50 text-slate-800'
              }`}
            >
              <span className="line-clamp-2">{row.name}</span>
              <span className="flex items-center gap-2">
                <StatusBadge status={row.status} />
                <span className="truncate font-mono text-[10px] text-slate-500">
                  {row.taskDefinitionName}
                </span>
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
